"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Cash = function Cash(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    d: "M19.503 16.694h-15a.625.625 0 01-.625-.625V7.944c0-.345.28-.625.625-.625h15c.345 0 .625.28.625.625v8.125c0 .345-.28.625-.625.625zm-.625-6.25a1.875 1.875 0 01-1.875-1.875h-10c0 1.036-.84 1.875-1.875 1.875v3.438c.915 0 1.695.66 1.847 1.562h10.056a1.874 1.874 0 011.847-1.562v-3.438zm-6.875 4.063c-1.142 0-1.875-.977-1.875-2.5 0-1.524.733-2.5 1.875-2.5 1.143 0 1.875.976 1.875 2.5 0 1.523-.732 2.5-1.875 2.5z",
    fill: "currentColor"
  }));
};

var _default = (0, _react.forwardRef)(Cash);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Cash, "Cash", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Cash.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Cash.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9DYXNoLnRzeCJdLCJuYW1lcyI6WyJDYXNoIiwicHJvcHMiLCJyZWYiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7QUFBQTs7Ozs7Ozs7Ozs7OztBQUVBLElBQU1BLElBQW9FLEdBQUcsU0FBdkVBLElBQXVFLENBQUNDLEtBQUQsRUFBUUMsR0FBUjtBQUFBLFNBQzNFO0FBQUssSUFBQSxLQUFLLEVBQUUsRUFBWjtBQUFnQixJQUFBLE1BQU0sRUFBRSxFQUF4QjtBQUE0QixJQUFBLE9BQU8sRUFBQztBQUFwQyxLQUFvREQsS0FBcEQ7QUFBMkQsSUFBQSxHQUFHLEVBQUVDO0FBQWhFLE1BQ0U7QUFDRSxJQUFBLENBQUMsRUFBQyx1WkFESjtBQUVFLElBQUEsSUFBSSxFQUFDO0FBRlAsSUFERixDQUQyRTtBQUFBLENBQTdFOztlQVNlLHVCQUFXRixJQUFYLEM7Ozs7Ozs7Ozs7Ozs7MEJBVFRBLEkiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgZm9yd2FyZFJlZiwgUmVmRm9yd2FyZGluZ0NvbXBvbmVudCwgU1ZHUHJvcHMgfSBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IENhc2g6IFJlZkZvcndhcmRpbmdDb21wb25lbnQ8U1ZHU1ZHRWxlbWVudCwgU1ZHUHJvcHM8U1ZHU1ZHRWxlbWVudD4+ID0gKHByb3BzLCByZWYpID0+IChcbiAgPHN2ZyB3aWR0aD17MjR9IGhlaWdodD17MjR9IHZpZXdCb3g9XCIwIDAgMjQgMjRcIiB7Li4ucHJvcHN9IHJlZj17cmVmfT5cbiAgICA8cGF0aFxuICAgICAgZD1cIk0xOS41MDMgMTYuNjk0aC0xNWEuNjI1LjYyNSAwIDAxLS42MjUtLjYyNVY3Ljk0NGMwLS4zNDUuMjgtLjYyNS42MjUtLjYyNWgxNWMuMzQ1IDAgLjYyNS4yOC42MjUuNjI1djguMTI1YzAgLjM0NS0uMjguNjI1LS42MjUuNjI1em0tLjYyNS02LjI1YTEuODc1IDEuODc1IDAgMDEtMS44NzUtMS44NzVoLTEwYzAgMS4wMzYtLjg0IDEuODc1LTEuODc1IDEuODc1djMuNDM4Yy45MTUgMCAxLjY5NS42NiAxLjg0NyAxLjU2MmgxMC4wNTZhMS44NzQgMS44NzQgMCAwMTEuODQ3LTEuNTYydi0zLjQzOHptLTYuODc1IDQuMDYzYy0xLjE0MiAwLTEuODc1LS45NzctMS44NzUtMi41IDAtMS41MjQuNzMzLTIuNSAxLjg3NS0yLjUgMS4xNDMgMCAxLjg3NS45NzYgMS44NzUgMi41IDAgMS41MjMtLjczMiAyLjUtMS44NzUgMi41elwiXG4gICAgICBmaWxsPVwiY3VycmVudENvbG9yXCJcbiAgICAvPlxuICA8L3N2Zz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IGZvcndhcmRSZWYoQ2FzaCk7XG4iXX0=